var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSucursal(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "55px",
    height: "55px",
    viewBox: "0 0 55 55",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "8.1 Sucursal") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Admin",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "2.10Reservaciones",
    transform: "translate(-468.000000, -309.000000)",
    stroke: "#FE8D27",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-4",
    transform: "translate(469.000000, 208.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-36",
    transform: "translate(0.000000, 93.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "8.1-Sucursal",
    transform: "translate(0.000000, 9.000000)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 26.5,
    cy: 26.5,
    r: 26.5
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-17",
    transform: "translate(15.000000, 16.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.0566788,9.28136419 L21.0566788,16.899391 C21.0566788,18.6114495 19.6681282,20 17.9560697,20 L4.66885903,20 C2.95680056,20 1.56825001,18.6114495 1.56825001,16.899391 L1.56825001,8.18708892",
    id: "Stroke-1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.29239131,8.97344702 C0.219553303,8.37320341 -0.330020387,7.01778319 0.21078351,5.77149817 L2.06120982,1.51327649 C2.45974819,0.594397077 3.36693455,0 4.36863978,0 L18.2560941,0 C19.2587738,0 20.1649857,0.594397077 20.5635241,1.51327649 L22.4139504,5.77149817 C22.9800892,7.07429963 22.3535363,8.49695493 21.1832561,9.05042631",
    id: "Stroke-3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.84966293,5.94007308 C5.84966293,7.44847747 4.62676402,8.67137637 3.11835964,8.67137637 C1.60995525,8.67137637 0.387056348,7.44847747 0.387056348,5.94007308",
    id: "Stroke-5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.3124644,5.94007308 C11.3124644,7.44847747 10.0895655,8.67137637 8.5811611,8.67137637 C7.07275671,8.67137637 5.84985781,7.44847747 5.84985781,5.94007308",
    id: "Stroke-7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.7753633,5.94007308 C16.7753633,7.44847747 15.5524644,8.67137637 14.04406,8.67137637 C12.5356556,8.67137637 11.3127567,7.44847747 11.3127567,5.94007308",
    id: "Stroke-9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.2381648,5.94007308 C22.2381648,7.44847747 21.0152658,8.67137637 19.5068615,8.67137637 C17.9984571,8.67137637 16.7755582,7.44847747 16.7755582,5.94007308",
    id: "Stroke-11"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 0.211173279,
    y1: 5.16384896,
    x2: 21.6270076,
    y2: 5.16384896,
    id: "Stroke-13"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.9519772,20 L8.67353625,20 L8.67353625,14.6825822 C8.67353625,13.9566382 9.2620868,13.3671133 9.98900519,13.3671133 L12.6365082,13.3671133 C13.3624522,13.3671133 13.9519772,13.9566382 13.9519772,14.6825822 L13.9519772,20 Z",
    id: "Stroke-15"
  })))))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSucursal);
export default __webpack_public_path__ + "static/media/Sucursal.35cae08801f2370345cd954ae459dec4.svg";
export { ForwardRef as ReactComponent };